import React, { useContext, useEffect } from 'react'

//context
import { OrgSettingsUsersContext } from '@/context/OrgSettingsUsersContext';
import { ResourcePermission } from  '@/interfaces/orgSettings';


const UseAdminDetailsScreen = () => {  
    const { userRole, getUserPermission, userId} = useContext(OrgSettingsUsersContext);
    const labelText = "ORGANISATION ROLE";
    let organisationRole = userRole === ResourcePermission.MANAGE ? "Admin" : "Member";
    
    useEffect(() => {
        organisationRole = userRole === ResourcePermission.MANAGE ? "Admin" : "Member";
    },[userRole]);

    useEffect(() => {
        if (userId) {
            getUserPermission();         
        }
    },[userId]);

    return {labelText, organisationRole, userRole}
}

export default UseAdminDetailsScreen